import React from 'react';
import { remittanceDialogSteps } from './Utils';
import { Button } from '@material-ui/core';
import LoadingButton from '../../lowLevel/LoadingButton';
import CancelButton from '../../BuildingBlocks/Button/CancelButton';

export default function DialogActions({
  step,
  setStepNumber,
  date,
  onCancel,
  loading,
  submitRequest,
  message,
}: {
  step: remittanceDialogSteps;
  setStepNumber: (step: remittanceDialogSteps) => void;
  date: any;
  onCancel: any;
  loading: boolean;
  submitRequest: () => void;
  message: String;
}) {
  return (
    <>
      {step === remittanceDialogSteps.remittanceDetails && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setStepNumber(remittanceDialogSteps.pickDate)}
        >
          continue
        </Button>
      )}
      {step === remittanceDialogSteps.pickDate && (
        <Button
          variant="contained"
          color="primary"
          disabled={!date}
          onClick={() => setStepNumber(remittanceDialogSteps.uploadFileSubmit)}
        >
          continue
        </Button>
      )}

      {step === remittanceDialogSteps.uploadFileSubmit && (
        <>
          <CancelButton
            onCancel={() => onCancel(true)}
            CancelText={'Cancel Request'}
            disabled={loading}
          />

          <LoadingButton
            variant="contained"
            color="primary"
            disabled={loading || !message}
            loading={loading}
            onClick={submitRequest}
            style={{ marginLeft: 'auto' }}
          >
            <b>Submit Request</b>
          </LoadingButton>
        </>
      )}

      {step === remittanceDialogSteps.submitRequest && (
        <Button variant="contained" color="primary" onClick={() => onCancel()}>
          Ok
        </Button>
      )}
    </>
  );
}
